const EVENT = "cc-booking-overlay-change";

export function bookingOverlayOpen(): boolean {
  return document.documentElement.dataset.bookCallPopupOpen === "true";
}
export function subscribeBookingOverlay(listener: () => void): () => void {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
export function setBookingOverlayOpen(open: boolean): void {
  if (open) document.documentElement.dataset.bookCallPopupOpen = "true";
  else delete document.documentElement.dataset.bookCallPopupOpen;
  window.dispatchEvent(new Event(EVENT));
}
